import Mensaje from "sweetalert";

/**
 * Devuelve opciones para jsPDF/pdfGenerator según A4 o tamaño personalizado.
 * Lanza Error si el usuario cancela o ingresa valores inválidos.
 */
export async function OpcionesEtiqueta(cantidadSeleccionada = 1) {
  // Paso 1: elegir A4 o Personalizado
  const eleccion = await new Promise((resolve) => {
    Mensaje({
      title: "Elegí el formato de etiqueta",
      text: `${cantidadSeleccionada} producto(s) seleccionado(s)`,
      icon: "info",
      buttons: {
        a4:       { text: "📄 A4 (predeterminado)", value: "a4", className: "btn-primary" },
        custom:   { text: "✏️ Personalizado…",      value: "custom", className: "btn-info" },
        cancel:   { text: "Cancelar",                value: null,    className: "btn-secondary" }
      }
    }).then(resolve);
  });

  if (!eleccion) throw new Error("Cancelado por el usuario");

  if (eleccion === "a4") {
    return {
      format: "a4",
      unit: "mm",
      orientation: "portrait",
      mostrarFecha: true,
      // si querés: productosPorPagina: 2, numerarProductos: true
    };
  }

 const contentEl = document.createElement("div");
  contentEl.style.display = "grid";
  contentEl.style.gridTemplateColumns = "auto auto";
  contentEl.style.gap = "8px";
  contentEl.innerHTML = `
    <label style="align-self:center;">Ancho (mm)</label>
    <input id="swal-ancho" type="number" min="1" step="0.1" placeholder="54" style="padding:6px; width:120px;" />
    <label style="align-self:center;">Alto (mm)</label>
    <input id="swal-alto" type="number" min="1" step="0.1" placeholder="25" style="padding:6px; width:120px;" />
  `;

  // Mostramos el modal con ambos campos
  await Mensaje({
    title: "Medidas personalizadas (mm)",
    text: "Ingresá ancho y alto en milímetros",
    icon: "info",
    content: contentEl,
    buttons: {
      cancel: { text: "Cancelar", value: null, className: "btn-secondary" },
      ok:     { text: "Aceptar",  value: "ok", className: "btn-primary", closeModal: false }
    },
    closeOnClickOutside: false,
    closeOnEsc: false
  }).then((val) => {
    if (val !== "ok") throw new Error("Cancelado");
    const anchoInput = contentEl.querySelector("#swal-ancho");
    const altoInput  = contentEl.querySelector("#swal-alto");

    const ancho = Number(String(anchoInput.value || "").replace(",", "."));
    const alto  = Number(String(altoInput.value  || "").replace(",", "."));

    if (!isFinite(ancho) || !isFinite(alto) || ancho <= 0 || alto <= 0) {
      throw new Error("Medidas inválidas");
    }

    // Guardamos en la propia función (closure) para devolver luego
    contentEl._result = { ancho, alto };
  }).finally(() => {
    // Cerrar el modal en caso de confirmación correcta
    try { Mensaje.close(); } catch {}
  });

  if (!contentEl._result) throw new Error("Cancelado");

  const { ancho, alto } = contentEl._result;

  // No A4 → 1 etiqueta por página
  return {
    format: [ancho, alto],
    unit: "mm",
    orientation: ancho > alto ? "landscape" : "portrait",
    mostrarFecha: false,
    productosPorPagina: 1,
    numerarProductos: false
  };
}
